









import { Component, Vue, Prop } from 'vue-property-decorator';
import SessionDetails from './SessionDetails.vue';

@Component({
  components: { SessionDetails },
})
export default class SessionDetailsRemote extends Vue {
  @Prop() id!: string;

  onClose() {
    this.$router.push({ name: 'sessions.all.title' });
  }

  onUpdate(data: any) {
    // No-op for direct route access — session table isn't mounted to update
  }
}
